<template>
  <div class="yx-statistics-xlcs-page main-layout">
    <el-card class="box-outter">
      <c-title slot="header" title="心理测试统计" :back="true"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <el-tabs v-model="currentTab" @tab-click="handleClick">
          <el-tab-pane label="数据列表" name="first">
            <div class="div-scroll">
              <div class="btn-group">
                <!-- 操作按钮 -->
                <div class="btn-left">
                  <el-button type="primary" plain @click="exportExcel()"
                    >导出</el-button
                  >
                </div>
                <!-- 右侧操作按钮 -->
                <table-btns
                  :tableColumns="tableColumns"
                  @tableColumnsChange="tableColumnsChange"
                  @refresh="
                    idList = [];
                    pageGet(true);
                  "
                ></table-btns>
              </div>
              <c-table
                :data="pageData"
                :tableColumns="tableColumns"
                :pagination="pageParams"
                @change="pageGet"
                @selectionChange="selectionChange"
                @edit="goto"
                @delete="pageDel"
                v-loading="pageLoading"
              >
              </c-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="简单分析" name="second">
            <div class="div-scroll">
              <div>
                <label for="">选取字段：</label>
                <el-select v-model="titleId" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button type="primary" class="ml10" @click="getChartData()"
                  >分析数据</el-button
                >
              </div>
              <div class="chart-div">
                <chart-one
                  v-if="chartFlag"
                  class="chart-div"
                  :value="chartData"
                  :text="titleName"
                ></chart-one>
              </div>
              <div class="chart-div">
                <chart-two
                  v-if="chartFlag"
                  class="chart-div"
                  :value="chartData"
                  :text="titleName"
                ></chart-two>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/xlcs";
import CTitle from "@/components/CTitle";
import ChartOne from "../charts/xlcsChart01";
import ChartTwo from "../charts/xlcsChart02";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import { getOrgOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-live/psytest/result/welcomeListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    // studentName: "",
    // collegeId: "",
    // departmentId: "",
    // majorId: "",
    // classId: "",
  },
});
export default {
  mixins: [mPage],
  name: "",
  components: { CTitle, CSearch, CTable, TableBtns, ChartOne, ChartTwo },
  data() {
    let { tableColumns } = Configs(this);
    return {
      tableColumns,
      idList: [],
      pageData: [],
      currentTab: "first",
      titleId: "",
      options: [],
      chartData: [],
      titleName: "",
      SUCCESS_CODE: "",
      chartFlag: true,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.getColumns();
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {},
    //获取动态表头
    getColumns() {
      this.$http
        .get("/welcome-live/psytest/result/getWelcomeColumns")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let columns = res.data;
            this.options = columns;
            if (this.options.length) {
              this.titleId = this.options[0].id;
            }
            columns.forEach((item) => {
              this.tableColumns.push({
                label: item.name,
                prop: item.id,
                align: "center",
                minWidth: 120,
                show: true,
              });
            });
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    //导出excel
    exportExcel() {
      let studentIdStr = this.idList.join();
      this.$http
        .post(
          "/welcome-live/psytest/result/welcomeExportExcel",
          studentIdStr,
          { responseType: "blob" }
        )
        .then((res) => {
          let filename = "心理测试结果.xls";
          this.download(res, filename);
        });
    },
    download(data, filename) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(
        new Blob([data], { type: "application/vnd.ms-excel" })
      );
      let link = document.createElement("a");
      link.download = filename;
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getChartData(val) {
      if (!this.titleId) return;
      this.$http
        .get(
          "/welcome-live/psytest/result/welcomeDataAnalysis?titleId=" +
            this.titleId
        )
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.chartData = res.data;
            this.chartFlag = false;
            this.$nextTick(() => {
              this.options.forEach((item) => {
                if (item.id == this.titleId) this.titleName = item.name;
              });
              this.chartFlag = true;
            });
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    goto(id) {},
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.searchItems[4].options = [];
      this.pageParams = {
        studentName: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
  },
};
</script>
<style scoped>
.chart-div {
  height: 350px;
}
.ml10 {
  margin-left: 10px;
}
</style>
